
import { Component, Vue } from 'vue-property-decorator';
import ExpandIcon from "@/components/utils/ExpandIcon.vue";

@Component({
    components:{
        ExpandIcon
    }
})
export default class AppealRecordTranscriptAppLeaveGrantedPg extends Vue {
    
    showAppealRecordTranscriptInfo = true;
    showNoaCaInfo = false;

    public showAppealRecordTranscript(show: boolean){
        if (show) {
            this.showAppealRecordTranscriptInfo = true;
            this.$emit('adjustHeights', 0, "15rem")
        } else {
            this.showAppealRecordTranscriptInfo = false;
            this.$emit('adjustHeights', 0, "0");
        }
    }

    public showNoaCa(show: boolean){
        if (show) {
            this.showNoaCaInfo = true;
            this.$emit('adjustHeights', 1, "4rem");
        } else {
            this.showNoaCaInfo = false;
            this.$emit('adjustHeights', 1, "0");
        }        
    }

}
